module.exports = __webpack_public_path__ + "img/file3.7b1fb5ab.png";